import styled from 'styled-components';
import { Typ41 } from 'dc/Typ';

type NPSContainerProps = {
  small?: boolean;
};

export const NPSContainer = styled.div<NPSContainerProps>`
  align-items: center;
  display: flex;
  flex-direction: ${props => (props.small ? 'column' : 'row')};
`;

export const NPSTopWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 280px;
  justify-content: space-between;
`;

type NPSBottomWrapperProps = {
  small?: boolean;
};

export const NPSBottomWrapper = styled.div<NPSBottomWrapperProps>`
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 232px;
  justify-content: space-between;
  margin-left: ${props => (props.small ? '0' : '8px')};
  margin-top: ${props => (props.small ? '13px' : '0')};
`;

type RadioButtonProps = {
  selected?: boolean;
};

export const RadioButton = styled.button<RadioButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: ${props => (props.selected ? '#007079' : '#f4f7f9')};
  border: 2px solid #0099a9;
  border-color: ${props => (props.selected ? '#007079' : '#0099a9')};
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    background: #007079;
    border-color: #007079;
    span {
      color: #fff;
    }
  }
`;

type ButtonTextProps = {
  selected?: boolean;
};

export const ButtonText = styled(Typ41)<ButtonTextProps>`
  font-size: 20px;
  color: ${props => (props.selected ? '#fff' : '#263238')};
`;
